import { createSlice } from '@reduxjs/toolkit';
import {
  fetchBlosgterFinalStageInsForm,
  fetchBlosgterFrameComplInsForm,
  fetchBlosgterStageInsForm,
  fetchBreakFrameLHForm,
  fetchSideFrameLHForm,
  listBlosgterStageInsForm,
  listBlosterFinalStageInsForm,
  listBogieFrameComplete,
  listSideFrameSi,
  listBreakBeamInspection,
  fetchviewBolsterStageInspection,
  fetchSpringTypes,
  fetchMasterBosterNo,
  fetchBogieDrawingNumber,
  fetchCapacity,
  fetchBogieFrameNo,
  fetchSideFrameMasterNo,
  fetchBreakBeamMasterNo,
  fetchBogieNo,
  fetchviewBolsterFinalStageInspection,
  fetchviewBreakBeamInspection,
  fetchviewSideFrameInspection,
  fetchviewBogieFrameInspection,
  stageInspLineAssembly,
  getBoggieForm50008B,
  fetchBogieFlowHistory,
  listBogieAssembly,
  fetchBogieFrameType,
  viewBogieAssemblyForm,
  fetchBogieAssemblyFlowHistory,
  fetchCompletedStages,
  listBogieStaticLoadAssembly,
  viewBogieStaticLoadAssemblyForm,
  fetchBogieStaticLoadAssemblyFlowHistory,
  storeDefectManagement,
} from './boggieThunk';

const initialState = {
  blosterStageIns: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  blosterFinalStageIns: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  blosterFrameCompIns: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  breakFrameLh: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  sideFrameLh: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  listblosterStageIns: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  listblosterFinalStageIns: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  listbogieFrameComplete: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  listBogieAssembly: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  completedStageBogieAssembly: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  listBogieStaticLoadAssembly: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewBogieStaticLoadAssembly: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  bogieStaticLoadAssemblyFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewBogieAssembly: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  bogieAssemblyFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  listBreakBeamIns: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  listSideFrameSi: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  inspLineAssembly: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  boggieForm: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  viewBolsterSi: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getSpringTypes: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getMasterBosterNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getDrwaingNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getCapacities: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getMasterBogieFrameNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getMasterBogieFrameType: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getMasterSideFrameNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  getMasterBreakBeamNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },

  getBogieNo: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewBolsterFinalSi: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewBogieFrameInspecion: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewSideFrameInspection: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  viewBreakBeam: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
  bogieFlowHistory: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
   // Defect Management
  defectManagement: {
    loading: false,
    success: false,
    error: null,
    data: [],
  },
};

const boggieSlice = createSlice({
  name: 'boggie',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlosgterStageInsForm.pending, (state) => {
        state.blosterStageIns.loading = true;
        state.blosterStageIns.error = null;
      })
      .addCase(fetchBlosgterStageInsForm.fulfilled, (state, action) => {
        state.blosterStageIns.loading = false;
        state.blosterStageIns.data = action.payload;
      })
      .addCase(fetchBlosgterStageInsForm.rejected, (state, action) => {
        state.blosterStageIns.loading = false;
        state.blosterStageIns.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchBlosgterFinalStageInsForm.pending, (state) => {
        state.blosterFinalStageIns.loading = true;
        state.blosterFinalStageIns.error = null;
      })
      .addCase(fetchBlosgterFinalStageInsForm.fulfilled, (state, action) => {
        state.blosterFinalStageIns.loading = false;
        state.blosterFinalStageIns.data = action.payload;
      })
      .addCase(fetchBlosgterFinalStageInsForm.rejected, (state, action) => {
        state.blosterFinalStageIns.loading = false;
        state.blosterFinalStageIns.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchBlosgterFrameComplInsForm.pending, (state) => {
        state.blosterFrameCompIns.loading = true;
        state.blosterFrameCompIns.error = null;
      })
      .addCase(fetchBlosgterFrameComplInsForm.fulfilled, (state, action) => {
        state.blosterFrameCompIns.loading = false;
        state.blosterFrameCompIns.data = action.payload;
      })
      .addCase(fetchBlosgterFrameComplInsForm.rejected, (state, action) => {
        state.blosterFrameCompIns.loading = false;
        state.blosterFrameCompIns.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchBreakFrameLHForm.pending, (state) => {
        state.breakFrameLh.loading = true;
        state.breakFrameLh.error = null;
      })
      .addCase(fetchBreakFrameLHForm.fulfilled, (state, action) => {
        state.breakFrameLh.loading = false;
        state.breakFrameLh.data = action.payload;
      })
      .addCase(fetchBreakFrameLHForm.rejected, (state, action) => {
        state.breakFrameLh.loading = false;
        state.breakFrameLh.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchSideFrameLHForm.pending, (state) => {
        state.sideFrameLh.loading = true;
        state.sideFrameLh.error = null;
      })
      .addCase(fetchSideFrameLHForm.fulfilled, (state, action) => {
        state.sideFrameLh.loading = false;
        state.sideFrameLh.data = action.payload;
      })
      .addCase(fetchSideFrameLHForm.rejected, (state, action) => {
        state.sideFrameLh.loading = false;
        state.sideFrameLh.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(listBlosgterStageInsForm.pending, (state) => {
        state.listblosterStageIns.loading = true;
        state.listblosterStageIns.error = null;
      })
      .addCase(listBlosgterStageInsForm.fulfilled, (state, action) => {
        state.listblosterStageIns.loading = false;
        state.listblosterStageIns.data = action.payload;
      })
      .addCase(listBlosgterStageInsForm.rejected, (state, action) => {
        state.listblosterFinalStageIns.loading = false;
        state.listblosterFinalStageIns.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(listBlosterFinalStageInsForm.pending, (state) => {
        state.listblosterFinalStageIns.loading = true;
        state.listblosterFinalStageIns.error = null;
      })
      .addCase(listBlosterFinalStageInsForm.fulfilled, (state, action) => {
        state.listblosterFinalStageIns.loading = false;
        state.listblosterFinalStageIns.data = action.payload;
      })
      .addCase(listBlosterFinalStageInsForm.rejected, (state, action) => {
        state.listblosterFinalStageIns.loading = false;
        state.listblosterFinalStageIns.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(listBogieFrameComplete.pending, (state) => {
        state.listbogieFrameComplete.loading = true;
        state.listbogieFrameComplete.error = null;
      })
      .addCase(listBogieFrameComplete.fulfilled, (state, action) => {
        state.listbogieFrameComplete.loading = false;
        state.listbogieFrameComplete.data = action.payload;
      })
      .addCase(listBogieFrameComplete.rejected, (state, action) => {
        state.listbogieFrameComplete.loading = false;
        state.listbogieFrameComplete.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(listBreakBeamInspection.pending, (state) => {
        state.listBreakBeamIns.loading = true;
        state.listBreakBeamIns.error = null;
      })
      .addCase(listBreakBeamInspection.fulfilled, (state, action) => {
        state.listBreakBeamIns.loading = false;
        state.listBreakBeamIns.data = action.payload;
      })
      .addCase(listBreakBeamInspection.rejected, (state, action) => {
        state.listBreakBeamIns.loading = false;
        state.listBreakBeamIns.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(listSideFrameSi.pending, (state) => {
        state.listSideFrameSi.loading = true;
        state.listSideFrameSi.error = null;
      })
      .addCase(listSideFrameSi.fulfilled, (state, action) => {
        state.listSideFrameSi.loading = false;
        state.listSideFrameSi.data = action.payload;
      })
      .addCase(listSideFrameSi.rejected, (state, action) => {
        state.listSideFrameSi.loading = false;
        state.listSideFrameSi.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(stageInspLineAssembly.pending, (state) => {
        state.inspLineAssembly.loading = true;
        state.inspLineAssembly.error = null;
      })
      .addCase(stageInspLineAssembly.fulfilled, (state, action) => {
        state.inspLineAssembly.loading = false;
        state.inspLineAssembly.data = action.payload;
      })
      .addCase(stageInspLineAssembly.rejected, (state, action) => {
        state.inspLineAssembly.loading = false;
        state.inspLineAssembly.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(getBoggieForm50008B.pending, (state) => {
        state.boggieForm.loading = true;
        state.boggieForm.error = null;
      })
      .addCase(getBoggieForm50008B.fulfilled, (state, action) => {
        state.boggieForm.loading = false;
        state.boggieForm.data = action.payload;
      })
      .addCase(getBoggieForm50008B.rejected, (state, action) => {
        state.boggieForm.loading = false;
        state.boggieForm.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchBogieDrawingNumber.pending, (state) => {
        state.getDrwaingNo.loading = true;
        state.getDrwaingNo.error = null;
      })
      .addCase(fetchBogieDrawingNumber.fulfilled, (state, action) => {
        state.getDrwaingNo.loading = false;
        state.getDrwaingNo.data = action.payload;
      })
      .addCase(fetchBogieDrawingNumber.rejected, (state, action) => {
        state.getDrwaingNo.loading = false;
        state.getDrwaingNo.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchMasterBosterNo.pending, (state) => {
        state.getMasterBosterNo.loading = true;
        state.getMasterBosterNo.error = null;
      })
      .addCase(fetchMasterBosterNo.fulfilled, (state, action) => {
        state.getMasterBosterNo.loading = false;
        state.getMasterBosterNo.data = action.payload;
      })
      .addCase(fetchMasterBosterNo.rejected, (state, action) => {
        state.getMasterBosterNo.loading = false;
        state.getMasterBosterNo.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchSpringTypes.pending, (state) => {
        state.getSpringTypes.loading = true;
        state.getSpringTypes.error = null;
      })
      .addCase(fetchSpringTypes.fulfilled, (state, action) => {
        state.getSpringTypes.loading = false;
        state.getSpringTypes.data = action.payload;
      })
      .addCase(fetchSpringTypes.rejected, (state, action) => {
        state.getSpringTypes.loading = false;
        state.getSpringTypes.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchCapacity.pending, (state) => {
        state.getCapacities.loading = true;
        state.getCapacities.error = null;
      })
      .addCase(fetchCapacity.fulfilled, (state, action) => {
        state.getCapacities.loading = false;
        state.getCapacities.data = action.payload;
      })
      .addCase(fetchCapacity.rejected, (state, action) => {
        state.getCapacities.loading = false;
        state.getCapacities.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchBogieFrameNo.pending, (state) => {
        state.getMasterBogieFrameNo.loading = true;
        state.getMasterBogieFrameNo.error = null;
      })
      .addCase(fetchBogieFrameNo.fulfilled, (state, action) => {
        state.getMasterBogieFrameNo.loading = false;
        state.getMasterBogieFrameNo.data = action.payload;
      })
      .addCase(fetchBogieFrameNo.rejected, (state, action) => {
        state.getMasterBogieFrameNo.loading = false;
        state.getMasterBogieFrameNo.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchBogieFrameType.pending, (state) => {
        state.getMasterBogieFrameType.loading = true;
        state.getMasterBogieFrameType.error = null;
      })
      .addCase(fetchBogieFrameType.fulfilled, (state, action) => {
        state.getMasterBogieFrameType.loading = false;
        state.getMasterBogieFrameType.data = action.payload;
      })
      .addCase(fetchBogieFrameType.rejected, (state, action) => {
        state.getMasterBogieFrameType.loading = false;
        state.getMasterBogieFrameType.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchSideFrameMasterNo.pending, (state) => {
        state.getMasterSideFrameNo.loading = true;
        state.getMasterSideFrameNo.error = null;
      })
      .addCase(fetchSideFrameMasterNo.fulfilled, (state, action) => {
        state.getMasterSideFrameNo.loading = false;
        state.getMasterSideFrameNo.data = action.payload;
      })
      .addCase(fetchSideFrameMasterNo.rejected, (state, action) => {
        state.getMasterSideFrameNo.loading = false;
        state.getMasterSideFrameNo.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchBreakBeamMasterNo.pending, (state) => {
        state.getMasterBreakBeamNo.loading = true;
        state.getMasterBreakBeamNo.error = null;
      })
      .addCase(fetchBreakBeamMasterNo.fulfilled, (state, action) => {
        state.getMasterBreakBeamNo.loading = false;
        state.getMasterBreakBeamNo.data = action.payload;
      })
      .addCase(fetchBreakBeamMasterNo.rejected, (state, action) => {
        state.getMasterBreakBeamNo.loading = false;
        state.getMasterBreakBeamNo.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchBogieNo.pending, (state) => {
        state.getBogieNo.loading = true;
        state.getBogieNo.error = null;
      })
      .addCase(fetchBogieNo.fulfilled, (state, action) => {
        state.getBogieNo.loading = false;
        state.getBogieNo.data = action.payload;
      })
      .addCase(fetchBogieNo.rejected, (state, action) => {
        state.getBogieNo.loading = false;
        state.getBogieNo.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchviewBolsterStageInspection.pending, (state) => {
        state.viewBolsterSi.loading = true;
        state.viewBolsterSi.error = null;
      })
      .addCase(fetchviewBolsterStageInspection.fulfilled, (state, action) => {
        state.viewBolsterSi.loading = false;
        state.viewBolsterSi.data = action.payload;
      })
      .addCase(fetchviewBolsterStageInspection.rejected, (state, action) => {
        state.viewBolsterSi.loading = false;
        state.viewBolsterSi.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchviewBolsterFinalStageInspection.pending, (state) => {
        state.viewBolsterFinalSi.loading = true;
        state.viewBolsterFinalSi.error = null;
      })
      .addCase(fetchviewBolsterFinalStageInspection.fulfilled, (state, action) => {
        state.viewBolsterFinalSi.loading = false;
        state.viewBolsterFinalSi.data = action.payload;
      })
      .addCase(fetchviewBolsterFinalStageInspection.rejected, (state, action) => {
        state.viewBolsterFinalSi.loading = false;
        state.viewBolsterFinalSi.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchviewBogieFrameInspection.pending, (state) => {
        state.viewBogieFrameInspecion.loading = true;
        state.viewBolsterFinalSi.error = null;
      })
      .addCase(fetchviewBogieFrameInspection.fulfilled, (state, action) => {
        state.viewBogieFrameInspecion.loading = false;
        state.viewBogieFrameInspecion.data = action.payload;
      })
      .addCase(fetchviewBogieFrameInspection.rejected, (state, action) => {
        state.viewBogieFrameInspecion.loading = false;
        state.viewBogieFrameInspecion.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchviewSideFrameInspection.pending, (state) => {
        state.viewSideFrameInspection.loading = true;
        state.viewSideFrameInspection.error = null;
      })
      .addCase(fetchviewSideFrameInspection.fulfilled, (state, action) => {
        state.viewSideFrameInspection.loading = false;
        state.viewSideFrameInspection.data = action.payload;
      })
      .addCase(fetchviewSideFrameInspection.rejected, (state, action) => {
        state.viewSideFrameInspection.loading = false;
        state.viewSideFrameInspection.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchviewBreakBeamInspection.pending, (state) => {
        state.viewBreakBeam.loading = true;
        state.viewBreakBeam.error = null;
      })
      .addCase(fetchviewBreakBeamInspection.fulfilled, (state, action) => {
        state.viewBreakBeam.loading = false;
        state.viewBreakBeam.data = action.payload;
      })
      .addCase(fetchviewBreakBeamInspection.rejected, (state, action) => {
        state.viewBreakBeam.loading = false;
        state.viewBreakBeam.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchBogieFlowHistory.pending, (state) => {
        state.bogieFlowHistory.loading = true;
        state.bogieFlowHistory.error = null;
      })
      .addCase(fetchBogieFlowHistory.fulfilled, (state, action) => {
        state.bogieFlowHistory.loading = false;
        state.bogieFlowHistory.success = true;
        state.bogieFlowHistory.data = action.payload.data;
      })
      .addCase(fetchBogieFlowHistory.rejected, (state, action) => {
        state.bogieFlowHistory.loading = false;
        state.bogieFlowHistory.success = false;
        state.bogieFlowHistory.error = action.payload || 'Failed to fetch flow history';
      })
      .addCase(listBogieAssembly.pending, (state) => {
        state.listBogieAssembly.loading = true;
        state.listBogieAssembly.error = null;
      })
      .addCase(listBogieAssembly.fulfilled, (state, action) => {
        state.listBogieAssembly.loading = false;
        state.listBogieAssembly.data = action.payload;
      })
      .addCase(listBogieAssembly.rejected, (state, action) => {
        state.listBogieAssembly.loading = false;
        state.listBogieAssembly.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(viewBogieAssemblyForm.pending, (state) => {
        state.viewBogieAssembly.loading = true;
        state.viewBogieAssembly.error = null;
      })
      .addCase(viewBogieAssemblyForm.fulfilled, (state, action) => {
        state.viewBogieAssembly.loading = false;
        state.viewBogieAssembly.data = action.payload;
      })
      .addCase(viewBogieAssemblyForm.rejected, (state, action) => {
        state.viewBogieAssembly.loading = false;
        state.viewBogieAssembly.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchBogieAssemblyFlowHistory.pending, (state) => {
        state.bogieAssemblyFlowHistory.loading = true;
        state.bogieAssemblyFlowHistory.error = null;
      })
      .addCase(fetchBogieAssemblyFlowHistory.fulfilled, (state, action) => {
        state.bogieAssemblyFlowHistory.loading = false;
        state.bogieAssemblyFlowHistory.data = action.payload?.data || [];
      })
      .addCase(fetchBogieAssemblyFlowHistory.rejected, (state, action) => {
        state.bogieAssemblyFlowHistory.loading = false;
        state.bogieAssemblyFlowHistory.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(fetchCompletedStages.pending, (state) => {
        state.completedStageBogieAssembly.loading = true;
        state.completedStageBogieAssembly.error = null;
      })
      .addCase(fetchCompletedStages.fulfilled, (state, action) => {
        state.completedStageBogieAssembly.loading = false;
        state.completedStageBogieAssembly.data = action.payload?.data;
      })
      .addCase(fetchCompletedStages.rejected, (state, action) => {
        state.completedStageBogieAssembly.loading = false;
        state.completedStageBogieAssembly.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(listBogieStaticLoadAssembly.pending, (state) => {
        state.listBogieStaticLoadAssembly.loading = true;
        state.listBogieStaticLoadAssembly.error = null;
      })
      .addCase(listBogieStaticLoadAssembly.fulfilled, (state, action) => {
        state.listBogieStaticLoadAssembly.loading = false;
        state.listBogieStaticLoadAssembly.data = action.payload;
      })
      .addCase(listBogieStaticLoadAssembly.rejected, (state, action) => {
        state.listBogieStaticLoadAssembly.loading = false;
        state.listBogieStaticLoadAssembly.error = action.payload || 'Somthing wents wrong.';
      })
      .addCase(viewBogieStaticLoadAssemblyForm.pending, (state) => {
        state.viewBogieStaticLoadAssembly.loading = true;
        state.viewBogieStaticLoadAssembly.error = null;
      })
      .addCase(viewBogieStaticLoadAssemblyForm.fulfilled, (state, action) => {
        state.viewBogieStaticLoadAssembly.loading = false;
        state.viewBogieStaticLoadAssembly.data = action.payload;
      })
      .addCase(viewBogieStaticLoadAssemblyForm.rejected, (state, action) => {
        state.viewBogieStaticLoadAssembly.loading = false;
        state.viewBogieStaticLoadAssembly.error = action.payload || 'Somthing wents wrong.';
      })

      .addCase(fetchBogieStaticLoadAssemblyFlowHistory.pending, (state) => {
        state.bogieStaticLoadAssemblyFlowHistory.loading = true;
        state.bogieStaticLoadAssemblyFlowHistory.error = null;
      })
      .addCase(fetchBogieStaticLoadAssemblyFlowHistory.fulfilled, (state, action) => {
        state.bogieStaticLoadAssemblyFlowHistory.loading = false;
        state.bogieStaticLoadAssemblyFlowHistory.data = action.payload?.data;
      })
      .addCase(fetchBogieStaticLoadAssemblyFlowHistory.rejected, (state, action) => {
        state.viewBogieSbogieStaticLoadAssemblyFlowHistorytaticLoadAssembly.loading = false;
        state.bogieStaticLoadAssemblyFlowHistory.error = action.payload || 'Somthing wents wrong.';
      })

         // Store Defect Management
      .addCase(storeDefectManagement.pending, (state) => {
        state.defectManagement.loading = true;
        state.defectManagement.error = null;
        state.defectManagement.success = false;
      })
      .addCase(storeDefectManagement.fulfilled, (state, action) => {
        state.defectManagement.loading = false;
        state.defectManagement.success = true;
        state.defectManagement.data = action.payload;
      })
      .addCase(storeDefectManagement.rejected, (state, action) => {
        state.defectManagement.loading = false;
        state.defectManagement.success = false;
        state.defectManagement.error = action.payload || 'Something went wrong.';
      });
  },
});


export default boggieSlice.reducer;
